import React from 'react';
import { Modal } from '@carbon/react';

/**
 * Passive confirmation shown after a password-reset mail was requested.
 * The wording never confirms whether the address actually exists.
 *
 * @param {object} props
 * @param {string} props.email - address the reset link was requested for
 * @param {() => void} props.hideModal - closes the modal
 */
const ConfirmPasswordResetModal = ({ email, hideModal }) => {
  return (
    <Modal
      open={true}
      danger={false}
      passiveModal={true}
      modalHeading="E-Mail versendet"
      onRequestClose={hideModal}
      onRequestSubmit={hideModal}>
      <p>
        Falls ein Konto für <strong>{email}</strong> existiert, ist eine E-Mail mit
        einem Link zum Zurücksetzen des Passworts unterwegs.
      </p>
      <br />
      <p>
        Klicke auf den Link in der E-Mail, um ein neues Passwort zu vergeben. Der
        Link ist nur begrenzte Zeit gültig.
      </p>
      <br />
      <p>
        Keine E-Mail erhalten? Bitte prüfe auch deinen Spam-Ordner.
      </p>
    </Modal>
  );
};

export default ConfirmPasswordResetModal;
